//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { addClickAnalytics } from 'utils/analytics';
export default {
  metaInfo: {
    title: '赚钱攻略'
  },
  data() {
    return {
    }
  },
  methods:{
    navToBack() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateBack();
        addClickAnalytics({ LogTitle: `赚钱攻略` });
      } else if(window.ReactNativeBridge) {
        addClickAnalytics({ LogTitle: `赚钱攻略` });
        window.ReactNativeBridge.call('NAVIGATION', {
          id: '',
          params: {},
          method: 'pop',
          success: (res) => {
            console.log(res);
          },
          fail: (err) => {
            console.error(err)
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/app/earnMoneyRules/page.vue